module.exports = __webpack_public_path__ + "static/img/examCenter.3ee4e00.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/exam/examCenter.png
// module id = mvXD
// module chunks = 1